import { useQuery } from "react-query";
import { WMSConfigServices } from "$services";
import { CacheInvalidationAction } from "$utils/cache";
import useAuth from "./useAuth";

export const useWMSConfigQuery = (warehouseId?: string) => {
  const { token } = useAuth();

  return useQuery(
    [CacheInvalidationAction.GET_WMS_CONFIG, warehouseId], // We might need to add this key to CacheInvalidationAction if it doesn't exist or use a string
    async () => {
      const response = await WMSConfigServices.GetWMSConfig(token, warehouseId);
      if (response?.error) {
        throw new Error(response.error);
      }
      return Array.isArray(response) ? response : [];
    },
    {
      enabled: !!token,
      staleTime: 10 * 60 * 1000,
    }
  );
};
